export default __webpack_public_path__ + "static/Thomas-Knight-350x350-38350ec2ce2124709d88491fd95114e9.jpg";